import { setDefaults as o } from "./index87.mjs";
import { setI18n as r } from "./index86.mjs";
const p = {
  type: "3rdParty",
  init(t) {
    o(t.options.react), r(t);
  }
};
export {
  p as initReactI18next
};
